// Footer Component
const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 px-6 py-4 flex items-center justify-between">
      <span className="text-sm text-gray-600">© Eye AI Pte Ltd, v2.1.0</span>
      <div className="flex items-center gap-2">
        <img
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='14'%3E%3Crect fill='%23012169' width='20' height='14'/%3E%3Cpath d='M0 0l20 14M20 0L0 14' stroke='%23fff' stroke-width='2.8'/%3E%3Cpath d='M0 0l20 14M20 0L0 14' stroke='%23C8102E' stroke-width='1.68'/%3E%3Cpath d='M8 0v14M0 4.67h20M0 9.33h20' stroke='%23fff' stroke-width='4.67'/%3E%3Cpath d='M8 0v14M0 4.67h20M0 9.33h20' stroke='%23C8102E' stroke-width='2.8'/%3E%3C/svg%3E"
          alt="UK Flag"
          className="w-5 h-4"
        />
        <span className="text-sm text-gray-700 font-medium">English</span>
      </div>
    </footer>
  );
};

export default Footer;